import { useEffect, useState } from 'react';

import {
  ListingWorkflowStatusIdTypes,
  PetWorkflowStatusIdTypes,
} from 'shared/types';
import {
  isListingWorkflowStatusIdPetWorkflowStatusApprove,
  isListingWorkflowStatusIdPetWorkflowStatusForwarded,
  isListingWorkflowStatusIdPetWorkflowStatusInProgress,
  isListingWorkflowStatusIdPetWorkflowStatusNotDefined,
  isListingWorkflowStatusIdPetWorkflowStatusPendingBreeder,
  isListingWorkflowStatusIdPetWorkflowStatusPendingReview,
} from 'utils/listing/checkers';
import { petWorkflowStatuses } from 'utils/status/petWorkflowStatus';

function usePetListingWorkflowStatus(
  workflowStatusId: ListingWorkflowStatusIdTypes | PetWorkflowStatusIdTypes
) {
  const [label, setLabel] = useState('');
  const [acronym, setAcronym] = useState('');
  const [slug, setSlug] = useState('');

  const handleSetStates = (workflowStatusId: ListingWorkflowStatusIdTypes) => {
    if (isListingWorkflowStatusIdPetWorkflowStatusApprove(workflowStatusId)) {
      setLabel(petWorkflowStatuses.approve.label);
      setAcronym(petWorkflowStatuses.approve.acronym);
      setSlug(petWorkflowStatuses.approve.slug);
      return;
    }

    if (
      isListingWorkflowStatusIdPetWorkflowStatusPendingReview(workflowStatusId)
    ) {
      setLabel(petWorkflowStatuses.pendingReview.label);
      setAcronym(petWorkflowStatuses.pendingReview.acronym);
      setSlug(petWorkflowStatuses.pendingReview.slug);
      return;
    }

    if (isListingWorkflowStatusIdPetWorkflowStatusForwarded(workflowStatusId)) {
      setLabel(petWorkflowStatuses.forwarded.label);
      setAcronym(petWorkflowStatuses.forwarded.acronym);
      setSlug(petWorkflowStatuses.forwarded.slug);
      return;
    }

    if (
      isListingWorkflowStatusIdPetWorkflowStatusInProgress(workflowStatusId)
    ) {
      setLabel(petWorkflowStatuses.inProgress.label);
      setAcronym(petWorkflowStatuses.inProgress.acronym);
      setSlug(petWorkflowStatuses.inProgress.slug);
      return;
    }

    if (
      isListingWorkflowStatusIdPetWorkflowStatusPendingBreeder(workflowStatusId)
    ) {
      setLabel(petWorkflowStatuses.pendingBreeder.label);
      setAcronym(petWorkflowStatuses.pendingBreeder.acronym);
      setSlug(petWorkflowStatuses.pendingBreeder.slug);
      return;
    }

    if (
      isListingWorkflowStatusIdPetWorkflowStatusNotDefined(workflowStatusId)
    ) {
      setLabel(petWorkflowStatuses.notDefined.label);
      setAcronym(petWorkflowStatuses.notDefined.acronym);
      setSlug(petWorkflowStatuses.notDefined.slug);
      return;
    }
  };

  useEffect(() => {
    if (workflowStatusId) {
      handleSetStates(workflowStatusId);
    } else {
      setLabel(petWorkflowStatuses.notDefined.label);
      setAcronym(petWorkflowStatuses.notDefined.acronym);
      setSlug(petWorkflowStatuses.notDefined.slug);
    }
  }, [workflowStatusId]);

  return {
    label,
    acronym,
    slug,
  };
}

export default usePetListingWorkflowStatus;
